<registration>
  <div class="wrap wrap02">
    <h1><img class="logo" src="/service_lp/img/logo.png" alt="BeatFit" /></h1>
    <img class="step" src="/service_lp/img/step02.png" alt="step02" />


    <label for="name">お名前<span if={ name_error } class="error-label"> ※入力してください</span></label>
    <input type="text" id="name" onFocusOut={ setName } placeholder="お名前を入力" />

    <label for="year">生年月日</label>

    <div class="select_container">
      <div class="select_area" onClick={ setYear }>
        <p class="label">年</p>
        <select id="year" name="year" class="select" onChange={ setYear }>
          <option each={ y in years } value={ y } selected={ y == 1980 }>{ y }</option>
        </select>
      </div>

      <div class="select_area" onClick={ setMonth }>
       <p class="label02">月</p>
       <select name="month" id="month" class="select02" onChange={ setMonth }>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
       </select>
      </div>

      <div class="select_area" onClick={ setDay }>
       <p class="label03">日</p>
       <select name="day" id="day" class="select03" onChange={ setDay }>
        <option each={ d in days } value={ d }>{ d }</option>
       </select>
      </div>
    </div>

    <label for="email">メールアドレス<span if={ email_error } class="error-label"> ※入力が正しくありません</span></label>
    <input type="email" id="email" onFocusOut={ setEmail } placeholder="メアドを入力">

    <label for="password">パスワード<span if={ password_error } class="error-label"> ※半角{ password_minimum_digits }文字以上で入力</span></label>
    <input type="password" id="password" onFocusOut={ setPassword } placeholder="{ password_minimum_digits }桁以上のパスワードを入力">

    <button if={ allow_registration } class="next" type="button" onClick={ showStripeModal }><img src="/image/renaissance/next.png" alt="次へ" /></button>
    <button if={ !allow_registration } class="next" type="button" disabled><img src="/image/renaissance/next.png" style="opacity: 0.5;" alt="次へ" /></button>

    <p>
      パスワードをお忘れの方は<a onClick={ resetPassword }>こちら</a><br>
    </p>

    <br />

    <p>無料体験のご利用はおひとり様1回のみです。<br>
      ご登録することで<a href="https://www.beatfit.jp/privacypolicy">プライバシーポリシー</a>と<br>
      <a href="https://www.beatfit.jp/termsofservice">利用規約</a>に同意します。
    </p>

    <br />

    <p>登録の過程で不具合等がございましたら、<br />
      お手数ですが <a href="mailto:support@beatfit.jp">support@beatfit.jp</a>まで<br />
      ご連絡ください
    </p>
  </div>

  <script>
    import "core-js/stable";
    import "regenerator-runtime/runtime";
    import User from '../model/user';
    var self = this

    self.name               = null
    self.email              = null
    self.password           = null
    self.year               = null
    self.month              = null
    self.day                = null
    self.birthday           = null
    self.allow_registration = false
    self.password_minimum_digits = 6

    self.year_text  = '年'
    self.month_text = '月'
    self.day_text   = '日'

    self.name_error      = false
    self.email_error     = false
    self.password_error  = false

    self.years = []

    if(window.innerWidth < 1024) {
      self.form_input_type = 'number'
    } else {
      self.form_input_type = 'text'
    }
    for(var i = 2015; i > 1930; i--) {
      self.years.push(i)
    }
    self.days = []
    for(var i = 1; 31 >= i; i++) {
      self.days.push(i)
    }

    setYear(e) {
      let year = parseInt($("#year").val())
      $('.label').text(year)
      $('.label').addClass('focus')
      self.year = year
      checkBirthday()
    }

    setMonth(e) {
      let month = parseInt($("#month").val())
      $('.label02').text(month)
      $('.label02').addClass('focus')
      self.month = month
      checkBirthday()
    }

    setDay(e) {
      let day = parseInt($("#day").val())
      $('.label03').text(day)
      $('.label03').addClass('focus')
      self.day = day
      checkBirthday()
    }

    setName(e) {
      let name = $(e.target).val()
      if(0 >= name.length) {
        self.name = null
        self.name_error = true
        return
      }
      self.name_error = false
      self.name = name
      checkInputForm()
    }

    setEmail(e) {
      let email  = $(e.target).val()
      if(email.match(/^([a-z0-9_\.\-])+@([a-z0-9_\.\-])+[^.]$/i)) {
        self.email = email
        self.email_error = false
      } else {
        self.email = null
        self.email_error = true
        return
      }
      checkInputForm()
    }


    setPassword(e) {
      let password  = $(e.target).val()
      if(self.password_minimum_digits > password.length) {
        self.password = null
        self.password_error = true
        return
      }
      self.password_error = false
      self.password = password
      checkInputForm()
    }

    function checkBirthday() {
      if(self.year && self.month && self.day) {
        if(String(self.month).length == 1) { self.month = `0${self.month}` }
        if(String(self.day).length == 1) { self.day = `0${self.day}` }
        self.birthday = moment(`${self.year}-${self.month}-${self.day}`)
      }
      checkInputForm()
    }

    function checkInputForm() {
      if(self.name && self.email && self.password && self.birthday) {
        self.allow_registration = true
      } else {
        self.allow_registration = false
      }
      self.update()
    }

    function checkUserAccount(email, password) {
      requestServerByPromise('/api/v1/auth/user/signin', 'POST', { email: email, password: password }).then((response) => {
        setToken(response.token)
        let user = null
        // uidを取得する
        requestServerByPromise('/api/v2/user/uid', 'POST', { email: email, password: password }).then((uidResponse) => {
          let user = new User(uidResponse)
          deleteCookie()
        })
        // 課金チェック
        user.checkReceiptData((isPaidFlg) => {
          if(user.isPaidFlg) {
            // 登録完了画面へ
            passiveLoading()
            riot.mount('already-register')
            self.unmount(true)
          } else {
            showStripeModal()
          }
        })
      }).catch((error) => {
        window.error('ご登録済みのメールアドレスですが、パスワードが正しくありません。', { message: error.message})
        return false
      })
    }

    function postRegistration(token) {
      // stripeからのcallbackがあったらlogをSentryに残す
      Raven.captureMessage('stripe callback log 1', {
        tags: { category: 'stripeCallback' },
        level: 'info'
      })
      registrationCheck(token)
    }

    async function showStripeModal() {
      activeLoading()

      const plan_name = obs.plan_name ? obs.plan_name :
                      obs.plan == "trial-monthly"     ? "月額プラン" :
                      obs.plan == "trial-half-yearly" ? "半年プラン" : "年額プラン"

      const amount = obs.amount ? obs.amount :
                   obs.plan == "trial-monthly"     ? 998  :
                   obs.plan == "trial-half-yearly" ? 4482 : 8148

      // sentryのログの仕込み(ユーザー情報)
      Raven.setUserContext({
        username: self.name,
        email:    self.email
      })

      StripeCheckout.open({
        key:             obs.stripeKey,
        name:            plan_name,
        panelLabel:      'クレジットカードで登録',
        email:           self.email,
        description:     '',
        amount:          amount,
        currency:        'jpy',
        panelLabel:      '決済する',
        allowRememberMe: false,
        locale:          'jp',
        token:           postRegistration // callback
      });
    }
    window.showStripeModal = showStripeModal

    async function registrationCheck(token) {
      // web登録である旨をdataにセットする
      let send_params = {
        //uid:          currentUser.uid,
        plan:         obs.plan,
        name:         self.name,
        email:        self.email,
        password:     self.password,
        birthday:     self.birthday.format("YYYY-MM-DD"),
        stripe_token: token.id,
        invite_token: obs.invite_token
      }
      // stripeからのcallbackがあったらlogをSentryに残す
      Raven.captureMessage('stripe callback log 2', {
        tags: { category: 'stripeCallback' },
        level: 'info'
      })
      requestServerByPromise('/api/v2/user/web_registration', 'POST', send_params).then((response) => {
        passiveLoading()
        if(!response.result) {
          return window.error('登録に失敗しました', response)
        } else if(response.confirm) {
          // 確認画面の表示
          riot.mount("confirm-noft", { hash_key: response.key })
          self.unmount(true)
        } else {
          location.href = generateRedirectUrl()
        }
      }).catch((error) => {
        return window.error('登録に失敗しました', error)
      })
    }

    // 完了画面のURLの生成
    function generateRedirectUrl() {
      let url = ""
      if(obs.invite_token) {
        url += "/friend/download"
      } else if(obs.plan.match(/family/)) {
        url += "/family/thanks"
      } else if(obs.plan.match(/campaign/)) {
        url += "/campaign/thanks"
      } else {
        url += "/download"
      }

      // 付属のパラメーターの設定
      url += `?plan=${obs.plan.replace("trial-", "")}`
      if(obs.p_id) {
        url += `&p=${obs.p_id}`
      }
      if(obs.invite_token) {
        url += `&invite_token=${obs.invite_token}`
      }

      return url
    }
    window.generateRedirectUrl = generateRedirectUrl

    resetPassword() {
      sendResetPasswordMail($('#email').val())
    }
  </script>
</registration>
